import React, { useState } from 'react';
import { Dialog } from '../ui/Dialog';
import { Button } from '../ui/Button';
import { apiJson } from '../../../components/apiClient';

const apiFin = (path, opts) => apiJson(`/financeiro${path}`, opts);
const fmtBRL = (v) => {
  const n = typeof v === 'string' ? parseFloat(v) : v;
  return typeof n === 'number' && !isNaN(n) ? n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—';
};
const hoje = () => new Date().toISOString().slice(0, 10);

// Registrar pagamento em no máximo 2 ações a partir da tabela (§8/§23 da
// evolução de produto): "..." → Registrar pagamento → Confirmar. Nunca
// obriga abrir o drawer completo só pra pagar. Reaproveita o mesmo
// endpoint que o drawer já usa (`POST /{tipo}s/{id}/pagamentos`).
export function RegistrarPagamentoDialog({ item, onClose, onChanged, showToast }) {
  const origem = item._origem === 'payable' ? 'payables' : 'receivables';
  const saldo = parseFloat(item.saldo ?? (parseFloat(item.valor) - parseFloat(item.valor_pago || 0)));
  const [valor, setValor] = useState(saldo > 0 ? String(saldo) : '');
  const [data, setData] = useState(hoje());
  const [forma, setForma] = useState(item.forma_pagamento_prevista || '');
  const [salvando, setSalvando] = useState(false);

  const confirmar = async () => {
    const v = parseFloat(valor);
    if (!v || v <= 0) { showToast('Informe um valor válido', 'error'); return; }
    if (v > saldo + 0.001) { showToast(`Valor maior que o saldo (${fmtBRL(saldo)})`, 'error'); return; }
    setSalvando(true);
    const r = await apiFin(`/${origem}/${item.id}/pagamentos`, {
      method: 'POST',
      body: JSON.stringify({ valor: v, data_pagamento: data, forma_pagamento: forma || undefined }),
    });
    setSalvando(false);
    if (r.status === 'ok' || r.pagamento_id) {
      showToast('Pagamento registrado!', 'success');
      onChanged?.();
      onClose();
    } else {
      showToast(r.mensagem || 'Erro ao registrar pagamento', 'error');
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      title="Registrar pagamento"
      footer={<Button variant="primary" loading={salvando} onClick={confirmar}>Confirmar</Button>}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--crm-space-3)' }}>
        <div className="crm-table-primary">{item.descricao}</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'var(--crm-text-sm)' }}>
          <span className="crm-form-hint">Saldo atual</span>
          <strong>{fmtBRL(saldo)}</strong>
        </div>
        <div className="crm-form-field">
          <label className="crm-form-label">Valor pago</label>
          <input className="crm-input" type="number" step="0.01" value={valor} onChange={(e) => setValor(e.target.value)} autoFocus />
        </div>
        <div className="crm-form-field">
          <label className="crm-form-label">Data</label>
          <input className="crm-input" type="date" value={data} onChange={(e) => setData(e.target.value)} />
        </div>
        <div className="crm-form-field">
          <label className="crm-form-label">Forma de pagamento</label>
          <select className="crm-select" value={forma} onChange={(e) => setForma(e.target.value)}>
            <option value="">—</option>
            <option value="PIX">PIX</option>
            <option value="BOLETO">Boleto</option>
            <option value="CARTAO">Cartão</option>
            <option value="TRANSFERENCIA">Transferência</option>
            <option value="DINHEIRO">Dinheiro</option>
          </select>
        </div>
      </div>
    </Dialog>
  );
}

export default RegistrarPagamentoDialog;
